(() => {
  if (customElements.get('product-zoom')) {
    return;
  }

  class ProductZoom extends HTMLElement {
    constructor() {
      super();
      this.body = document.querySelector('body');
      this.toggles = document.querySelectorAll(this.dataset.toggle)
      this.atc = document.querySelector('.product-form__buttons');
      this.header = document.querySelector('.header-group');
      this.images = this.querySelectorAll('.product-zoom__image');
      this.featuredImage = this.querySelector('.product-zoom__featured img');
      this.thumbnails = this.querySelectorAll('.product-zoom__thumb');
      this.selectedMediaId = this.thumbnails[0].dataset.imageId;
    }

    connectedCallback() {
      this.bindEvents();
      this.toggleZoom();
    }

    bindEvents() {
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          this.selectedMediaId = thumbnail.dataset.imageId;
          this.selectFeaturedImage();
        });
      })
    }

    toggleZoom() {
      this.toggles.forEach(toggleButton => {
        toggleButton.addEventListener('click', (event) => {
          event.preventDefault();

          // select the image in focus
          if(toggleButton.classList.contains('product-info__zoom')) {
            this.selectedMediaId = toggleButton.closest('.product-info__image').id.replace('image-', '');
            this.selectFeaturedImage();
          }

          this.classList.toggle('open');
          this.body.classList.toggle('body-locked');
        });
      });
    }

    selectFeaturedImage() {
      this.thumbnails.forEach(el => {
        el.classList.remove('active')
        const img = el.querySelector('img');
        img.classList.remove('hidden');
        //preload image
        let preloadImg = new Image();
        preloadImg.src = img.src;
        if(el.dataset.imageId === this.selectedMediaId) {
          el.classList.add('active');
          this.featuredImage.src = img.src;
          this.featuredImage.srcset = img.srcset;
          this.featuredImage.classList.remove('hidden');
        } else {
          el.classList.remove('active');
        }
      });
    }
  }

  customElements.define('product-zoom', ProductZoom);
})();
